import { Conversation } from 'lib-shared-legacy-types';

export function isNewestFacebookConversation(
  conversation: Conversation,
  latestFacebookConversationId: number,
): boolean {
  if (!latestFacebookConversationId || !conversation.id) {
    return false;
  }

  return conversation.id >= latestFacebookConversationId;
}
